import { doc, updateDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Domain from '../../models/Domain';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function updateDomain(
  domain: Domain,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new UpdateDomainFailure('Unauthorized', 'unauthorized');
  }

  try {
    const domainDocPatch = domain.toFirestorePatch();
    const db = firestore;

    await updateDoc(
      doc(db, FirestoreCollections.domains, domain.id),
      domainDocPatch
    );

    return;
  } catch (e) {
    console.log('error: ', e);
    throw new UpdateDomainFailure();
  }
}

export class UpdateDomainFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateDomain;
